
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iDxDj", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $3lWl0 = parcelRequire("3lWl0");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $3jwuS = parcelRequire("3jwuS");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");



var $e4o8D = parcelRequire("e4o8D");


var $7Sm4c = parcelRequire("7Sm4c");


var $laFNM = parcelRequire("laFNM");


var $qP1yw = parcelRequire("qP1yw");


var $8EyOs = parcelRequire("8EyOs");


var $bJX6u = parcelRequire("bJX6u");


var $3qCob = parcelRequire("3qCob");

function $f084987bc41bc5d5$var$computeContentStateValuesFromData(data, defaultStatesArray, customStatesArray, isDraft, contentId, isViewOnlyMode) {
    const newContentStateValues = Object.assign({}, (0, $bJX6u.defaultValues));
    /**  Computes content state values from query response data. Used for both SSR bootstrap (useEffect never runs on
    server, so we compute state from preloaded data for initial render) and client useEffect (setInitialValues).
    Setting shouldRunContentStateEffect = false prevents the effect from running again on parent re-renders
    (EditorContentState lives in breadcrumbs/title area), which would otherwise reset the values.
  */ newContentStateValues.shouldRunContentStateEffect = false;
    newContentStateValues.contentState = data?.singleContent?.contentState || null;
    newContentStateValues.contentStateLastUpdated = data?.singleContent?.contentStateLastUpdated?.value || null;
    newContentStateValues.defaultStatesArray = defaultStatesArray;
    newContentStateValues.customStatesArray = customStatesArray;
    // Only check availableContentStates when the user has edit permission.
    // In view-only mode, availableContentStates is either skipped via @skip directive
    // or absent entirely (renderer fallback query), so we must not treat its absence
    // as "content states disabled".
    if (!isViewOnlyMode) {
        const editorData = data;
        const isSuggestedContentStatesDisabled = !editorData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !editorData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) newContentStateValues.isCustomEnabled = false;
    }
    newContentStateValues.lastFetchedIsDraft = isDraft;
    newContentStateValues.lastFetchedContentId = contentId;
    return newContentStateValues;
}
const $f084987bc41bc5d5$var$EditorContentStateDataGetter = (t0)=>{
    const $ = (0, $bDgLe.c)(100);
    const { contentId: contentId, contentType: contentType, contentStateState: contentStateState, isPublishingContent: isPublishingContent, userOffline: userOffline, onContentStateMenuToggle: onContentStateMenuToggle, floatingToolbarButtonStyle: floatingToolbarButtonStyle, renderPlusButtonEmptyState: renderPlusButtonEmptyState, isDetailsPanel: isDetailsPanel, onClick: onClick, isViewMode: isViewMode, canEdit: canEdit } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    const isDraft = !isViewMode && !isCurrentPageLive;
    const { approvalRequest: approvalRequest } = (0, $laFNM.useApprovals)();
    const hasApprovalStatus = !!approvalRequest?.application?.workflowStatusId;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const isViewOnlyMode = !!(isViewMode && canEdit === false);
    let t1;
    if ($[0] !== isCurrentPageLive) {
        t1 = (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? false : !isCurrentPageLive;
        $[0] = isCurrentPageLive;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== contentId || $[4] !== isDraft || $[5] !== isViewOnlyMode || $[6] !== t1) {
        t3 = {
            contentId: contentId,
            isDraft: isDraft,
            shouldSkipContentStateLastUpdated: t1,
            isApprovalsFgOn: t2,
            format: (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? "MILLIS" : "USER_FRIENDLY",
            shouldSkipAvailableContentStates: isViewOnlyMode,
            shouldSkipEditOnlyFields: isViewOnlyMode
        };
        $[3] = contentId;
        $[4] = isDraft;
        $[5] = isViewOnlyMode;
        $[6] = t1;
        $[7] = t3;
    } else t3 = $[7];
    const t4 = t3;
    const t5 = (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? false : !contentStateState.state.shouldRunContentStateEffect;
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
        t6 = {
            fetchPolicy: window.__SSR_RENDERED__ ? "cache-first" : "network-only",
            variables: t4,
            skip: t5
        };
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const { data: data, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $3lWl0.default), {
        ...t6,
        __callerPackage__: "content-state"
    });
    let t7;
    if ($[11] !== contentId || $[12] !== isDraft) {
        t7 = {
            contentId: contentId,
            isDraft: isDraft,
            format: "USER_FRIENDLY"
        };
        $[11] = contentId;
        $[12] = isDraft;
        $[13] = t7;
    } else t7 = $[13];
    const t8 = t7;
    const t9 = !isViewOnlyMode;
    let t10;
    if ($[14] !== t8 || $[15] !== t9) {
        t10 = {
            fetchPolicy: "cache-first",
            variables: t8,
            skip: t9
        };
        $[14] = t8;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    const { data: rendererData } = (0, $jMyy4.useQueryInterop)((0, $8EyOs.default), {
        ...t10,
        __callerPackage__: "content-state"
    });
    const ssrContentStateData = renderServerPlaceholder && isViewOnlyMode && !data && !rendererData ? window.__SSR_CONTENT_STATE__ : null;
    const effectiveData = data ?? (isViewOnlyMode ? rendererData ?? ssrContentStateData : null);
    data?.availableContentStates?.spaceContentStates;
    let t11;
    if ($[17] !== data?.availableContentStates?.spaceContentStates) {
        t11 = data?.availableContentStates?.spaceContentStates?.filter($f084987bc41bc5d5$var$_temp) || [];
        $[17] = data?.availableContentStates?.spaceContentStates;
        $[18] = t11;
    } else t11 = $[18];
    const defaultStatesArray = t11;
    let t12;
    if ($[19] !== data?.availableContentStates?.customContentStates) {
        t12 = ()=>data?.availableContentStates?.customContentStates?.filter($f084987bc41bc5d5$var$_temp2) || [];
        $[19] = data?.availableContentStates?.customContentStates;
        $[20] = t12;
    } else t12 = $[20];
    data?.availableContentStates?.customContentStates;
    let t13;
    if ($[21] !== t12) {
        t13 = t12();
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    const customStatesArray = t13;
    let ssrContentState = null;
    if (renderServerPlaceholder && (isViewOnlyMode || (0, $6mKj3.expValEquals)("content_state_ssr_improvements_exp", "isEnabled", true)) && effectiveData && effectiveData.singleContent?.id === contentId && contentStateState.state.lastFetchedIsDraft === null && ((0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) || contentStateState.state.shouldRunContentStateEffect)) {
        let t14;
        if ($[23] !== contentId || $[24] !== customStatesArray || $[25] !== defaultStatesArray || $[26] !== effectiveData || $[27] !== isDraft || $[28] !== isViewOnlyMode) {
            t14 = $f084987bc41bc5d5$var$computeContentStateValuesFromData(effectiveData, defaultStatesArray, customStatesArray, isDraft, contentId, isViewOnlyMode);
            $[23] = contentId;
            $[24] = customStatesArray;
            $[25] = defaultStatesArray;
            $[26] = effectiveData;
            $[27] = isDraft;
            $[28] = isViewOnlyMode;
            $[29] = t14;
        } else t14 = $[29];
        ssrContentState = t14;
    }
    if (renderServerPlaceholder && !ssrContentState && !effectiveData && (hasApprovalStatus || isViewOnlyMode) && contentStateState.state.lastFetchedIsDraft === null && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) {
        let t14;
        if ($[30] !== contentId || $[31] !== isDraft) {
            t14 = {
                ...(0, $bJX6u.defaultValues),
                isContentStateEnabled: false,
                shouldRunContentStateEffect: false,
                lastFetchedIsDraft: isDraft,
                lastFetchedContentId: contentId
            };
            $[30] = contentId;
            $[31] = isDraft;
            $[32] = t14;
        } else t14 = $[32];
        ssrContentState = t14;
    }
    const effectiveState = ssrContentState ?? contentStateState.state;
    let t14;
    if ($[33] !== contentStateState.state.lastFetchedIsDraft || $[34] !== isDraft) {
        t14 = contentStateState.state.lastFetchedIsDraft !== null && contentStateState.state.lastFetchedIsDraft !== isDraft && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[33] = contentStateState.state.lastFetchedIsDraft;
        $[34] = isDraft;
        $[35] = t14;
    } else t14 = $[35];
    const isTransitioning = t14;
    let t15;
    let t16;
    if ($[36] !== contentStateState || $[37] !== isTransitioning) {
        t15 = ()=>{
            if (isTransitioning) contentStateState.resetToDefaults();
        };
        t16 = [
            isTransitioning,
            contentStateState
        ];
        $[36] = contentStateState;
        $[37] = isTransitioning;
        $[38] = t15;
        $[39] = t16;
    } else {
        t15 = $[38];
        t16 = $[39];
    }
    (0, $cozmU.useEffect)(t15, t16);
    let t17;
    let t18;
    if ($[40] !== contentId || $[41] !== contentStateState || $[42] !== effectiveData || $[43] !== error || $[44] !== isDraft || $[45] !== isTransitioning || $[46] !== isViewOnlyMode) {
        t17 = ()=>{
            if (!isTransitioning && error) {
                if (isViewOnlyMode && effectiveData) (0, $7Sm4c.markErrorAsHandled)(error);
                else if (!effectiveData && contentStateState.state.shouldRunContentStateEffect && contentStateState.state.lastFetchedIsDraft === null) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    contentStateState.setInitialValues({
                        ...(0, $bJX6u.defaultValues),
                        isContentStateEnabled: false,
                        shouldRunContentStateEffect: false,
                        lastFetchedIsDraft: isDraft,
                        lastFetchedContentId: contentId
                    });
                }
            }
        };
        t18 = [
            error,
            effectiveData,
            contentStateState,
            isDraft,
            contentId,
            isTransitioning,
            isViewOnlyMode
        ];
        $[40] = contentId;
        $[41] = contentStateState;
        $[42] = effectiveData;
        $[43] = error;
        $[44] = isDraft;
        $[45] = isTransitioning;
        $[46] = isViewOnlyMode;
        $[47] = t17;
        $[48] = t18;
    } else {
        t17 = $[47];
        t18 = $[48];
    }
    (0, $cozmU.useEffect)(t17, t18);
    let t19;
    let t20;
    if ($[49] !== contentId || $[50] !== contentStateState || $[51] !== customStatesArray || $[52] !== defaultStatesArray || $[53] !== effectiveData || $[54] !== isDraft || $[55] !== isTransitioning || $[56] !== isViewOnlyMode) {
        t19 = ()=>{
            if (isTransitioning) return;
            if (effectiveData && effectiveData.singleContent?.id === contentId && ((0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) || contentStateState.state.shouldRunContentStateEffect)) {
                if (contentStateState.state.isUpdating) {
                    contentStateState.setIsUpdating(false);
                    return;
                }
                const computed = $f084987bc41bc5d5$var$computeContentStateValuesFromData(effectiveData, defaultStatesArray, customStatesArray, isDraft, contentId, isViewOnlyMode);
                if (contentStateState.isOptimisticOperationPending) {
                    computed.contentState = contentStateState.state.contentState;
                    computed.contentStateLastUpdated = contentStateState.state.contentStateLastUpdated;
                    computed.customStatesArray = contentStateState.state.customStatesArray;
                } else if ((0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) computed.customStatesArray = (0, $3qCob.reAddAppliedCustomStatusIfMissing)(computed.contentState, computed.customStatesArray, computed.defaultStatesArray, contentStateState.state.customStatesArray);
                contentStateState.setInitialValues(computed);
            }
        };
        t20 = [
            effectiveData,
            contentStateState,
            defaultStatesArray,
            customStatesArray,
            isDraft,
            isTransitioning,
            contentId,
            isViewOnlyMode
        ];
        $[49] = contentId;
        $[50] = contentStateState;
        $[51] = customStatesArray;
        $[52] = defaultStatesArray;
        $[53] = effectiveData;
        $[54] = isDraft;
        $[55] = isTransitioning;
        $[56] = isViewOnlyMode;
        $[57] = t19;
        $[58] = t20;
    } else {
        t19 = $[57];
        t20 = $[58];
    }
    (0, $cozmU.useEffect)(t19, t20);
    let t21;
    let t22;
    if ($[59] !== contentId || $[60] !== contentStateState) {
        t21 = ()=>{
            const guardedContentId = contentStateState.keepEmptyTriggerForContentId;
            if (guardedContentId !== null && guardedContentId !== contentId) contentStateState.setKeepEmptyTriggerForContentId(null);
        };
        t22 = [
            contentId,
            contentStateState
        ];
        $[59] = contentId;
        $[60] = contentStateState;
        $[61] = t21;
        $[62] = t22;
    } else {
        t21 = $[61];
        t22 = $[62];
    }
    (0, $cozmU.useEffect)(t21, t22);
    let t23;
    if ($[63] !== contentId || $[64] !== contentStateState.keepEmptyTriggerForContentId || $[65] !== effectiveState || $[66] !== isTransitioning || $[67] !== isViewMode) {
        t23 = isViewMode && contentStateState.keepEmptyTriggerForContentId === contentId && !isTransitioning && !(effectiveState.lastFetchedContentId !== null && effectiveState.lastFetchedContentId !== contentId && (0, $9wGTI.fg)("confluence_frontend_transition_preloading_system")) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true);
        $[63] = contentId;
        $[64] = contentStateState.keepEmptyTriggerForContentId;
        $[65] = effectiveState;
        $[66] = isTransitioning;
        $[67] = isViewMode;
        $[68] = t23;
    } else t23 = $[68];
    const keepEmptyTriggerVisible = t23;
    let t24;
    if ($[69] !== canEdit || $[70] !== contentId || $[71] !== contentType || $[72] !== effectiveState || $[73] !== floatingToolbarButtonStyle || $[74] !== hasApprovalStatus || $[75] !== isTransitioning || $[76] !== isViewMode || $[77] !== keepEmptyTriggerVisible || $[78] !== renderPlusButtonEmptyState) {
        t24 = keepEmptyTriggerVisible || !isTransitioning && !(effectiveState.lastFetchedContentId !== null && effectiveState.lastFetchedContentId !== contentId && (0, $9wGTI.fg)("confluence_frontend_transition_preloading_system")) && !(effectiveState.shouldRunContentStateEffect && effectiveState.lastFetchedIsDraft === null) && !(!effectiveState.isContentStateEnabled && !effectiveState.contentState && !hasApprovalStatus && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) && !(isViewMode && !canEdit && !(effectiveState.contentState || hasApprovalStatus) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) && !(isViewMode && contentType === "blogpost" && !(effectiveState.contentState || hasApprovalStatus) && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) && !(!(effectiveState.contentState || hasApprovalStatus) && !floatingToolbarButtonStyle && !renderPlusButtonEmptyState && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true));
        $[69] = canEdit;
        $[70] = contentId;
        $[71] = contentType;
        $[72] = effectiveState;
        $[73] = floatingToolbarButtonStyle;
        $[74] = hasApprovalStatus;
        $[75] = isTransitioning;
        $[76] = isViewMode;
        $[77] = keepEmptyTriggerVisible;
        $[78] = renderPlusButtonEmptyState;
        $[79] = t24;
    } else t24 = $[79];
    const shouldRenderUI = t24;
    if (shouldRenderUI && isPublishingContent) createAnalyticsEvent({
        type: "sendTrackEvent",
        data: {
            action: "publishedWithContentState",
            actionSubject: "page",
            objectId: contentId,
            source: "editorContentState",
            attributes: {
                contentStatus: isViewMode ? "CURRENT" : "DRAFT"
            }
        }
    }).fire();
    let t25;
    if ($[80] !== isViewMode || $[81] !== refetch) {
        t25 = isViewMode && (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
            name: "content-state",
            types: [
                (0, $c0urc.ReloadType).content
            ],
            reload: refetch
        });
        $[80] = isViewMode;
        $[81] = refetch;
        $[82] = t25;
    } else t25 = $[82];
    let t26;
    if ($[83] !== canEdit || $[84] !== contentId || $[85] !== contentStateState || $[86] !== contentType || $[87] !== effectiveState || $[88] !== floatingToolbarButtonStyle || $[89] !== isDetailsPanel || $[90] !== isViewMode || $[91] !== onClick || $[92] !== onContentStateMenuToggle || $[93] !== renderPlusButtonEmptyState || $[94] !== shouldRenderUI || $[95] !== userOffline) {
        t26 = shouldRenderUI && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $qP1yw.LazyEditorContentStateComponent), {
            contentId: contentId,
            contentType: contentType,
            contentStateState: {
                ...contentStateState,
                state: effectiveState
            },
            userOffline: userOffline,
            onContentStateMenuToggle: onContentStateMenuToggle,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            renderPlusButtonEmptyState: renderPlusButtonEmptyState,
            isDetailsPanel: isDetailsPanel,
            onClick: onClick,
            isViewMode: isViewMode,
            canEdit: canEdit
        });
        $[83] = canEdit;
        $[84] = contentId;
        $[85] = contentStateState;
        $[86] = contentType;
        $[87] = effectiveState;
        $[88] = floatingToolbarButtonStyle;
        $[89] = isDetailsPanel;
        $[90] = isViewMode;
        $[91] = onClick;
        $[92] = onContentStateMenuToggle;
        $[93] = renderPlusButtonEmptyState;
        $[94] = shouldRenderUI;
        $[95] = userOffline;
        $[96] = t26;
    } else t26 = $[96];
    let t27;
    if ($[97] !== t25 || $[98] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t25, t26);
        $[97] = t25;
        $[98] = t26;
        $[99] = t27;
    } else t27 = $[99];
    return t27;
};
const $f084987bc41bc5d5$var$EditorContentStateWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($f084987bc41bc5d5$var$EditorContentStateDataGetter);
const $f084987bc41bc5d5$var$contentStateContainers = [
    (0, $bJX6u.ContentStateStateContainer)
];
const $f084987bc41bc5d5$export$2791e79b1a186ba4 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: $f084987bc41bc5d5$var$contentStateContainers
        }, (contentStateState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f084987bc41bc5d5$var$EditorContentStateWithErrorBoundary, {
                ...props,
                contentStateState: contentStateState
            }));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
function $f084987bc41bc5d5$var$_temp(i) {
    return !!i;
}
function $f084987bc41bc5d5$var$_temp2(i_0) {
    return !!i_0;
}
module.exports["EditorContentState"] = $f084987bc41bc5d5$export$2791e79b1a186ba4;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<f94631fe88bfaea1f9346228f17314d1>>
 * @relayHash e78f45ef84b0309b46cad2982bdd129a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipAvailableContentStates"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipEditOnlyFields"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "color"
    }, v11 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "shouldSkipEditOnlyFields",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCallerPermitted"
                                }
                            ]
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "shouldSkipAvailableContentStates",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "AvailableContentStates",
                    "kind": "LinkedField",
                    "name": "availableContentStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "customContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "spaceContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e78f45ef84b0309b46cad2982bdd129a",
            "id": "d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!,$shouldSkipAvailableContentStates:Boolean=false,$shouldSkipEditOnlyFields:Boolean=false){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted@skip(if:$shouldSkipEditOnlyFields),lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId)@skip(if:$shouldSkipAvailableContentStates){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "f76426744ff28f16601d3ae4d51a17fb";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("qP1yw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $lJswu = parcelRequire("lJswu");


var $dzxx6 = parcelRequire("dzxx6");


const $d4d6077acc6972b1$export$a5601a59fc831df9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "qET7f",
    name: "LazyEditorContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("anXfn"))).EditorContentStateComponent;
    },
    loading: (0, $lJswu.ContentStateSkeleton)
});

const $d4d6077acc6972b1$export$c49c9d91fa2cc91e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "OYB6O",
    name: "LazyRendererContentStateComponent",
    loader: async ()=>{
        return (await (parcelRequire("ejQ8j"))).RendererContentStateComponent;
    },
    loading: (0, $dzxx6.RendererContentStatePlaceholder)
});
module.exports["LazyEditorContentStateComponent"] = $d4d6077acc6972b1$export$a5601a59fc831df9;
module.exports["LazyRendererContentStateComponent"] = $d4d6077acc6972b1$export$c49c9d91fa2cc91e;

});

parcelRegister("lJswu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");

const $668f42f1e7477ee9$export$ad2edbf08e0f7b11 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            width: "60px",
            height: "20px",
            isShimmering: true,
            testId: "content-state-skeleton"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentStateSkeleton"] = $668f42f1e7477ee9$export$ad2edbf08e0f7b11;

});

parcelRegister("dzxx6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kA6Zo = parcelRequire("kA6Zo");

const $62a49c8d20755563$var$loadingPlaceholderStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    minHeight: '32px',
    borderRadius: 'radius.small',
    paddingRight: 'space.100',
    backgroundColor: 'utility.elevation.surface.current'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62a49c8d20755563$var$ContentStateNamePlaceholderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_k48p1wq8 _3um015vq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $62a49c8d20755563$var$contentStateColorPlaceholderStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.full',
    height: '10px',
    width: '10px',
    marginLeft: 'space.050',
    marginRight: 'space.075',
    backgroundColor: 'color.background.neutral'
});
const $62a49c8d20755563$var$flexWrapperStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.075',
    marginRight: 'space.075'
});
const $62a49c8d20755563$export$6679211e6c7373d = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { contentState: contentState } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $62a49c8d20755563$var$contentStateColorPlaceholderStyles,
            testId: "subtle-renderer-content-state-color-placeholder"
        });
        $[0] = t1;
    } else t1 = $[0];
    const t2 = contentState?.name;
    let t3;
    if ($[1] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $62a49c8d20755563$var$flexWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            as: "li",
            alignItems: "center",
            xcss: $62a49c8d20755563$var$loadingPlaceholderStyles,
            testId: "subtle-renderer-content-state-placeholder"
        }, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($62a49c8d20755563$var$ContentStateNamePlaceholderWrapper, null, t2)));
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
};
module.exports["RendererContentStatePlaceholder"] = $62a49c8d20755563$export$6679211e6c7373d;

});

parcelRegister("anXfn", function(module, exports) {

let $78fa0292f37a9349$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $78fa0292f37a9349$var$load("daX4F"),
    $78fa0292f37a9349$var$load("9OOy8"),
    $78fa0292f37a9349$var$load("ce92V"),
    $78fa0292f37a9349$var$load("6WPx8"),
    $78fa0292f37a9349$var$load("aP4DK"),
    $78fa0292f37a9349$var$load("4XkGy"),
    $78fa0292f37a9349$var$load("9J1M7"),
    $78fa0292f37a9349$var$load("dgerE"),
    $78fa0292f37a9349$var$load("h4Nf7"),
    $78fa0292f37a9349$var$load("7wlV6"),
    $78fa0292f37a9349$var$load("el56J"),
    $78fa0292f37a9349$var$load("6wr18"),
    $78fa0292f37a9349$var$load("59hV4"),
    $78fa0292f37a9349$var$load("4x9Jx"),
    $78fa0292f37a9349$var$load("96waY"),
    $78fa0292f37a9349$var$load("fuOfV"),
    $78fa0292f37a9349$var$load("jL1Ke"),
    $78fa0292f37a9349$var$load("5MQ0D"),
    $78fa0292f37a9349$var$load("b2yG5"),
    $78fa0292f37a9349$var$load("fnmAQ"),
    $78fa0292f37a9349$var$load("5Mm1x"),
    $78fa0292f37a9349$var$load("9cpj1"),
    $78fa0292f37a9349$var$load("ffEVr"),
    $78fa0292f37a9349$var$load("jZMUd"),
    $78fa0292f37a9349$var$load("2EIkU"),
    $78fa0292f37a9349$var$load("8rQM5"),
    $78fa0292f37a9349$var$load("7rWWN"),
    $78fa0292f37a9349$var$load("cuWsK"),
    $78fa0292f37a9349$var$load("35yiN"),
    $78fa0292f37a9349$var$load("Wowvf"),
    $78fa0292f37a9349$var$load("eRhBr"),
    $78fa0292f37a9349$var$load("hhss7"),
    $78fa0292f37a9349$var$load("7EorR"),
    $78fa0292f37a9349$var$load("9DDT5")
]).then(()=>parcelRequire('2TweP'));

});

parcelRegister("ejQ8j", function(module, exports) {

let $a6cb4794d1294ded$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6cb4794d1294ded$var$load("jcEo4").then(()=>parcelRequire('llcSD'));

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<dd6200b047aed134b0d9af6a992daf7b>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $kNIYN.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        // Guards optimistic, mutation-owned fields (applied status + option list) from being
        // clobbered by stale refetches while an operation is pending. Kept off `state` so it
        // survives the refetch-driven `setInitialValues` calls.
        this.isOptimisticOperationPending = false;
        this.setIsOptimisticOperationPending = (isOptimisticOperationPending)=>{
            this.isOptimisticOperationPending = isOptimisticOperationPending;
        };
        // The contentId for which the empty add-status trigger should be kept visible after a
        // view-mode delete. Stored as an id (not a boolean) so render can scope it to the current page
        // without a navigation listener — it's only honored while this matches the active contentId,
        // so it naturally clears on navigation. Kept off `state` so a fresh container (refresh) resets it.
        this.keepEmptyTriggerForContentId = null;
        this.setKeepEmptyTriggerForContentId = (contentId)=>{
            this.keepEmptyTriggerForContentId = contentId;
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("3qCob", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");

const $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES = 3;
function $41e22d3f43a50651$export$86566dc9e85acb0c(primaryColor) {
    const tokenPrimaryColor = (0, $8miSe.hexToToken)(primaryColor ?? (0, $Uu0Pb.PRIMARY_COLORS).BLUE);
    switch(tokenPrimaryColor){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE:
            return (0, $Uu0Pb.SECONDARY_COLORS).BLUE;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN:
            return (0, $Uu0Pb.SECONDARY_COLORS).GREEN;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW:
            return (0, $Uu0Pb.SECONDARY_COLORS).YELLOW;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED:
            return (0, $Uu0Pb.SECONDARY_COLORS).RED;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE:
            return (0, $Uu0Pb.SECONDARY_COLORS).PURPLE;
        default:
            return (0, $Uu0Pb.SECONDARY_COLORS).BLUE;
    }
}
function $41e22d3f43a50651$export$6844ce2c0353a555(secondaryColor) {
    const tokenSecondaryColor = (0, $8miSe.hexToToken)(secondaryColor ?? (0, $Uu0Pb.SECONDARY_COLORS).BLUE);
    switch(tokenSecondaryColor){
        case (0, $Uu0Pb.SECONDARY_COLORS).BLUE:
            return (0, $Uu0Pb.HOVER_COLORS).BLUE;
        case (0, $Uu0Pb.SECONDARY_COLORS).GREEN:
            return (0, $Uu0Pb.HOVER_COLORS).GREEN;
        case (0, $Uu0Pb.SECONDARY_COLORS).YELLOW:
            return (0, $Uu0Pb.HOVER_COLORS).YELLOW;
        case (0, $Uu0Pb.SECONDARY_COLORS).RED:
            return (0, $Uu0Pb.HOVER_COLORS).RED;
        case (0, $Uu0Pb.SECONDARY_COLORS).PURPLE:
            return (0, $Uu0Pb.HOVER_COLORS).PURPLE;
        default:
            return (0, $Uu0Pb.HOVER_COLORS).BLUE;
    }
}
function $41e22d3f43a50651$export$ccc9fe24e363c71e(oldContentState, newContentState) {
    if (!oldContentState) return false; // can't be duplicate if we don't even have a content state originally
    return oldContentState.name === newContentState.name && oldContentState.color === newContentState.color;
}
function $41e22d3f43a50651$export$a2f9d64eff18382c(customStatesArray, newCustomState) {
    for(let i = 0; i < customStatesArray.length; ++i){
        if ($41e22d3f43a50651$export$ccc9fe24e363c71e(customStatesArray[i], newCustomState)) return {
            index: i,
            id: customStatesArray[i]?.id
        };
    }
    // if we don't find a match just return null
    return null;
}
function $41e22d3f43a50651$export$cd8fa131e8c8f91e(oldCustomStatesArray, newCustomState) {
    /* Need to check if the state user entered matches an existing custom one in the array.
   If it's a duplicate, it means the state the user just typed in is one that already exists. We must find the index
   and id in the old array and handle it like if an existing custom state was selected
    */ const idAndIndex = $41e22d3f43a50651$export$a2f9d64eff18382c(oldCustomStatesArray, newCustomState);
    if (idAndIndex) // user typed in an existing custom state
    return $41e22d3f43a50651$export$1c741d2b42a2932b(oldCustomStatesArray, {
        ...newCustomState,
        id: idAndIndex.id
    }, idAndIndex.index);
    else {
        const newArray = [
            newCustomState,
            ...oldCustomStatesArray
        ];
        if (newArray.length > $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES) newArray.pop();
        return newArray;
    }
}
function $41e22d3f43a50651$export$1c741d2b42a2932b(oldCustomStatesArray, selectedCustomState, index) {
    // removed the selected custom state by index and then add it to the top of the new array
    const newArray = [
        ...oldCustomStatesArray
    ];
    newArray.splice(index, 1);
    newArray.unshift(selectedCustomState);
    return newArray;
}
const $41e22d3f43a50651$export$7366fe55fc696c82 = 'temp-';
function $41e22d3f43a50651$export$b63091a1c8126966(oldCustomStatesArray, newCustomState) {
    // Drop null entries, the optimistic placeholder, and any prior entry that matches the
    // newly-created state by name or id, so the server state is added exactly once. The type
    // guard narrows the result to ContentState[] (no nulls survive the filter).
    const withoutPlaceholders = oldCustomStatesArray.filter((state)=>state != null && !state.id?.startsWith($41e22d3f43a50651$export$7366fe55fc696c82) && state.name !== newCustomState.name && (newCustomState.id == null || state.id !== newCustomState.id));
    const newArray = [
        newCustomState,
        ...withoutPlaceholders
    ];
    if (newArray.length > $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES) newArray.length = $41e22d3f43a50651$var$MAX_ALLOWED_CUSTOM_STATES;
    return newArray;
}
function $41e22d3f43a50651$export$6d0553ade1700746(appliedContentState, refetchedCustomStatesArray, defaultStatesArray, locallyKnownCustomStatesArray) {
    const isAppliedCustom = !!appliedContentState?.id && !defaultStatesArray.some((s)=>s?.id === appliedContentState.id);
    const missingFromRefetch = isAppliedCustom && !refetchedCustomStatesArray.some((s)=>s?.id === appliedContentState?.id);
    const knownLocally = locallyKnownCustomStatesArray.some((s)=>s?.id === appliedContentState?.id);
    if (missingFromRefetch && knownLocally && appliedContentState) return [
        appliedContentState,
        ...refetchedCustomStatesArray
    ];
    return refetchedCustomStatesArray;
}
module.exports["determineSecondaryColor"] = $41e22d3f43a50651$export$86566dc9e85acb0c;
module.exports["determineHoverColor"] = $41e22d3f43a50651$export$6844ce2c0353a555;
module.exports["isDuplicate"] = $41e22d3f43a50651$export$ccc9fe24e363c71e;
module.exports["createNewCustomStatesArrayWhenNewCustomAdded"] = $41e22d3f43a50651$export$cd8fa131e8c8f91e;
module.exports["createNewCustomStatesArrayWhenExistingCustomSelected"] = $41e22d3f43a50651$export$1c741d2b42a2932b;
module.exports["OPTIMISTIC_CUSTOM_STATE_ID_PREFIX"] = $41e22d3f43a50651$export$7366fe55fc696c82;
module.exports["reconcileCustomStatesAfterCreate"] = $41e22d3f43a50651$export$b63091a1c8126966;
module.exports["reAddAppliedCustomStatusIfMissing"] = $41e22d3f43a50651$export$6d0553ade1700746;

});

parcelRegister("Uu0Pb", function(module, exports) {
const $1c48b1994652ad1b$export$af156f0af92331bd = {
    BLUE: "var(--ds-background-accent-blue-subtle, #669DF1)",
    GREEN: "var(--ds-background-accent-green-subtle, #4BCE97)",
    YELLOW: "var(--ds-background-accent-yellow-subtle, #EED12B)",
    RED: "var(--ds-background-accent-red-subtle, #F87168)",
    PURPLE: "var(--ds-background-accent-purple-subtle, #C97CF4)",
    VERIFIED: "var(--ds-icon-accent-blue, #357DE8)"
};
const $1c48b1994652ad1b$export$c70dda424cd479ac = {
    BLUE: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    GREEN: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    YELLOW: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    RED: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    PURPLE: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
};
const $1c48b1994652ad1b$export$8380141af31d7b6a = {
    BLUE: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    GREEN: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    YELLOW: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    RED: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    PURPLE: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)"
};
const $1c48b1994652ad1b$export$e755b4518de49373 = {
    BLUE: 'blue',
    GREEN: 'green',
    YELLOW: 'yellow',
    RED: 'red',
    PURPLE: 'purple'
};
module.exports["PRIMARY_COLORS"] = $1c48b1994652ad1b$export$af156f0af92331bd;
module.exports["SECONDARY_COLORS"] = $1c48b1994652ad1b$export$c70dda424cd479ac;
module.exports["HOVER_COLORS"] = $1c48b1994652ad1b$export$8380141af31d7b6a;
module.exports["COLOR_NAMES"] = $1c48b1994652ad1b$export$e755b4518de49373;

});

parcelRegister("8miSe", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $Uu0Pb = parcelRequire("Uu0Pb");

const $38122f14841a6560$export$b3a997d9e0eb41e = (color)=>{
    switch(color){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE:
            return '#2684FF';
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN:
            return '#57D9A3';
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW:
            return '#FFC400';
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE:
            return '#8777D9';
        case (0, $Uu0Pb.PRIMARY_COLORS).RED:
            return '#FF7452';
        case (0, $Uu0Pb.PRIMARY_COLORS).VERIFIED:
            return '#1d7afc';
        default:
            return '#2684FF';
    }
};
const $38122f14841a6560$export$979ed8c2392c1cb4 = (color)=>{
    const upperCaseColor = color?.toUpperCase(); // need toUpper since color we get from BE is lowercase
    switch(upperCaseColor){
        case '#2684FF':
            return (0, $Uu0Pb.PRIMARY_COLORS).BLUE;
        case '#57D9A3':
            return (0, $Uu0Pb.PRIMARY_COLORS).GREEN;
        case '#FFC400':
            return (0, $Uu0Pb.PRIMARY_COLORS).YELLOW;
        case '#8777D9':
            return (0, $Uu0Pb.PRIMARY_COLORS).PURPLE;
        case '#FF7452':
            return (0, $Uu0Pb.PRIMARY_COLORS).RED;
        default:
            return color;
    }
};
function $38122f14841a6560$export$4407ed99ceb09a2c(colorCode) {
    const upperCaseColorCode = colorCode?.toUpperCase();
    switch(upperCaseColorCode){
        case (0, $Uu0Pb.PRIMARY_COLORS).BLUE.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).BLUE;
        case (0, $Uu0Pb.PRIMARY_COLORS).GREEN.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).GREEN;
        case (0, $Uu0Pb.PRIMARY_COLORS).YELLOW.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).YELLOW;
        case (0, $Uu0Pb.PRIMARY_COLORS).RED.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).RED;
        case (0, $Uu0Pb.PRIMARY_COLORS).PURPLE.toUpperCase():
            return (0, $Uu0Pb.COLOR_NAMES).PURPLE;
        default:
            return (0, $Uu0Pb.COLOR_NAMES).BLUE;
    }
}
module.exports["tokenToHex"] = $38122f14841a6560$export$b3a997d9e0eb41e;
module.exports["hexToToken"] = $38122f14841a6560$export$979ed8c2392c1cb4;
module.exports["colorCodeToColorName"] = $38122f14841a6560$export$4407ed99ceb09a2c;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId,
                status: [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            fetchPolicy: 'cache-first'
        } : {
            query: (0, $63cta.ContentOperationsQuery),
            variables: {
                contentId: contentId
            }
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            variables: {
                contentId: contentId,
                status: status ?? [
                    'current',
                    'archived',
                    'draft'
                ]
            },
            skip: !contentId,
            fetchPolicy: 'cache-first'
        } : {
            variables: {
                contentId: contentId,
                status: status
            },
            skip: !contentId
        },
        __callerPackage__: "entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        ...(0, $6mKj3.expValEquals)('confluence_content_operations_cache_first', 'cohort', 'experiment') ? {
            fetchPolicy: 'cache-first'
        } : {},
        __callerPackage__: "entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<247131d79908e150d144b65bd18338c4>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<a98ec14c52d173566241d54d72eed0e4>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<d4c33eb851813f5d8bdf7b8ddf9d7fb7>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "4ac4e53f1dd0ba665b3f48217ce7b74b";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<eaa114c9e42c98e4d30da80006b4df1f>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "5796c3a83a0773d6d932bd63d2fbf511";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                if ((0, $9wGTI.fg)("forge-ui-fix-forge-confluence-mainlayout-rerender")) setSidebars($8facebd0ecb5e0ee$var$_temp);
                else setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("4S6vT", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $Uu0Pb = parcelRequire("Uu0Pb");


var $8miSe = parcelRequire("8miSe");

const $87c020c14703301f$var$ContentStateColorSizes = {
    pageHistoryContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '10px',
            width: '10px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginLeft: 'space.050',
            marginRight: 'space.050'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        }),
        scale: 'scale(0.625)',
        viewbox: '0 0 10px 10px'
    },
    rendererContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '12px',
            width: '12px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginRight: 'space.100',
            marginLeft: 'space.100'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.xlarge',
            width: '12px',
            height: '12px'
        }),
        scale: 'scale(0.75)',
        viewbox: '0 0 12px 12px'
    },
    editorContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '16px',
            width: '16px',
            marginTop: 'space.0',
            marginBottom: 'space.0',
            marginLeft: 'space.400',
            marginRight: 'space.400'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    contentStateButton: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '12px',
            width: '12px',
            marginRight: 'space.050'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.xlarge',
            width: '12px',
            height: '12px'
        }),
        scale: 'scale(0.75)',
        viewbox: '0 0 12px 12px'
    },
    spaceAdminContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            maxHeight: '16px',
            maxWidth: '16px',
            marginRight: 'space.200'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    restoreContentStatesModal: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            maxHeight: '16px',
            maxWidth: '16px'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    },
    subtleContentStateButton: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '24px',
            width: '24px',
            marginRight: 'space.negative.025'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        })
    },
    subtleRendererContentState: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '24px',
            width: '24px'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '10px',
            height: '10px'
        })
    },
    contentStateInfoPopup: {
        ColorContainerStyles: (0, $buxP3.xcss)({
            height: '16px',
            width: '16px',
            marginRight: 'space.100'
        }),
        PlainContentStateColorStyles: (0, $buxP3.xcss)({
            borderRadius: 'radius.full',
            width: '16px',
            height: '16px'
        }),
        scale: 'scale(1)',
        viewbox: '0 0 16px 16px'
    }
};
// The SVG defaults to 16x16
// We need to scale to different sizes
const $87c020c14703301f$var$CheckCircleSvg = (color, dataTestId, scale, viewbox)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "100%",
        height: "100%",
        viewBox: viewbox,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'block'
        },
        "data-testid": dataTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        transform: scale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.62505 0.990813C8.94443 -0.330271 7.05558 -0.330271 6.37496 0.990813C5.96598 1.78463 5.04334 2.1668 4.19284 1.89468C2.77742 1.4418 1.4418 2.77742 1.89468 4.19284C2.1668 5.04334 1.78463 5.96598 0.990813 6.37496C-0.330271 7.05558 -0.330271 8.94443 0.990813 9.62505C1.78463 10.034 2.1668 10.9567 1.89468 11.8072C1.4418 13.2226 2.77742 14.5582 4.19284 14.1053C5.04334 13.8332 5.96598 14.2154 6.37496 15.0092C7.05558 16.3303 8.94443 16.3303 9.62505 15.0092C10.034 14.2154 10.9567 13.8332 11.8072 14.1053C13.2226 14.5582 14.5582 13.2226 14.1053 11.8072C13.8332 10.9567 14.2154 10.034 15.0092 9.62505C16.3303 8.94443 16.3303 7.05558 15.0092 6.37496C14.2154 5.96598 13.8332 5.04334 14.1053 4.19284C14.5582 2.77742 13.2226 1.4418 11.8072 1.89468C10.9567 2.1668 10.034 1.78463 9.62505 0.990813ZM11.2176 5.5246L11.2951 5.59368C11.6175 5.91602 11.6405 6.42433 11.3642 6.77323L11.2951 6.85076L7.73956 10.4063C7.41722 10.7287 6.90894 10.7517 6.56003 10.4754L6.48251 10.4063L4.70473 8.62854C4.3576 8.28141 4.3576 7.71859 4.70473 7.37146C5.02707 7.04912 5.53535 7.02609 5.88425 7.30238L5.96178 7.37146L7.11117 8.52029L10.0381 5.59368C10.3604 5.27134 10.8687 5.24831 11.2176 5.5246Z",
        fill: color
    })));
const $87c020c14703301f$var$getDisplayedColor = (color, isWarning)=>{
    if (isWarning) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? '#FF7452' : (0, $Uu0Pb.PRIMARY_COLORS).RED;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined) ? color : (0, $8miSe.hexToToken)(color);
};
const $87c020c14703301f$export$5ac2229016dfa3b6 = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { color: color, restrictionLevel: t1, appearance: appearance, isWarning: t2, dataTestId: dataTestId } = t0;
    const restrictionLevel = t1 === undefined ? "NONE" : t1;
    const isWarning = t2 === undefined ? false : t2;
    const { ColorContainerStyles: ColorContainerStyles, viewbox: viewbox, PlainContentStateColorStyles: PlainContentStateColorStyles, scale: scale } = $87c020c14703301f$var$ContentStateColorSizes[appearance];
    let T0;
    let t3;
    let t4;
    if ($[0] !== ColorContainerStyles || $[1] !== PlainContentStateColorStyles || $[2] !== color || $[3] !== dataTestId || $[4] !== isWarning || $[5] !== restrictionLevel || $[6] !== scale || $[7] !== viewbox) {
        const displayedColor = $87c020c14703301f$var$getDisplayedColor(color ?? "#2684FF", isWarning);
        const isRestrictedState = restrictionLevel !== "NONE" && !isWarning;
        T0 = (0, $3izAL.default);
        t3 = ColorContainerStyles;
        t4 = isRestrictedState ? $87c020c14703301f$var$CheckCircleSvg(displayedColor, dataTestId, scale, viewbox) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: dataTestId,
            xcss: PlainContentStateColorStyles,
            style: {
                backgroundColor: displayedColor,
                scale: scale
            }
        });
        $[0] = ColorContainerStyles;
        $[1] = PlainContentStateColorStyles;
        $[2] = color;
        $[3] = dataTestId;
        $[4] = isWarning;
        $[5] = restrictionLevel;
        $[6] = scale;
        $[7] = viewbox;
        $[8] = T0;
        $[9] = t3;
        $[10] = t4;
    } else {
        T0 = $[8];
        t3 = $[9];
        t4 = $[10];
    }
    let t5;
    if ($[11] !== T0 || $[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t3
        }, t4);
        $[11] = T0;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
module.exports["ContentStateColor"] = $87c020c14703301f$export$5ac2229016dfa3b6;

});


//# sourceMappingURL=EditorContentState.4963807d.js.map
